
//TODO_TS: Rename this to singular
export var MeasurementTypes = {
  MEASUREMENT_DISTANCE: 1, // Measurement from point to point, not matter what geometry it is.
  MEASUREMENT_ANGLE: 2,
  MEASUREMENT_AREA: 3,
  CALIBRATION: 4,
  MEASUREMENT_CALLOUT: 5,
  MEASUREMENT_SPOT: 6,
  MEASUREMENT_ARC: 7,
  MEASUREMENT_LASER: 8, // Measurement from point to point, but using a laser pointer.
  MEASUREMENT_SHORTEST_DISTANCE: 9, // Measurement from point to point, but using a shortest distance algorithm.
  MEASUREMENT_SURFACE: 10, // Measurement of surface area and properties.
  MEASUREMENT_SLOPE: 11 // Measurement of the slope of a surface.
};

export var MeasurementTypesToAnalytics = {
  [MeasurementTypes.MEASUREMENT_DISTANCE]: 'Distance',
  [MeasurementTypes.MEASUREMENT_ANGLE]: 'Angle',
  [MeasurementTypes.MEASUREMENT_AREA]: 'Area',
  [MeasurementTypes.CALIBRATION]: 'Calibration',
  [MeasurementTypes.MEASUREMENT_CALLOUT]: 'Callout',
  [MeasurementTypes.MEASUREMENT_SPOT]: 'Spot',
  [MeasurementTypes.MEASUREMENT_ARC]: 'Arc',
  [MeasurementTypes.MEASUREMENT_LASER]: 'Laser',
  [MeasurementTypes.MEASUREMENT_SHORTEST_DISTANCE]: 'Shortest Distance',
  [MeasurementTypes.MEASUREMENT_SURFACE]: 'Surface',
  [MeasurementTypes.MEASUREMENT_SLOPE]: 'Slope'
};